import { render, staticRenderFns } from "./OrganizationPacketMultiPoint.vue?vue&type=template&id=1a65e0e4&scoped=true&"
import script from "./OrganizationPacketMultiPoint.vue?vue&type=script&lang=ts&"
export * from "./OrganizationPacketMultiPoint.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationPacketMultiPoint.vue?vue&type=style&index=0&id=1a65e0e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a65e0e4",
  null
  
)

export default component.exports